var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"prize-list"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"prize-list-item"},[_c('img',{staticClass:"prize-list-img",attrs:{"src":item,"alt":""}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }